"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useHotKeys = require("./useHotKeys");
Object.keys(_useHotKeys).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useHotKeys[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useHotKeys[key];
    }
  });
});